export default defineNuxtRouteMiddleware(async (to, from) => {
  
  // const { $fetchProject, $fetchUser, $fetchAnn } = useNuxtApp();
  // await Promise.all([$fetchProject(), $fetchUser(), $fetchAnn()]);

  const { $fetchHome } = useNuxtApp();
  await $fetchHome();

});
